import React from 'react';
import update from 'react-addons-update';
import cx from 'classnames';
import Submenu from './Submenu';
import MapLink from '../MapLink';
import canUseDOM from '../../../common/canUseDom';

class DesktopLocationMenu extends Submenu {

  constructor(props) {
    super(props);
    this.analytics = this.props.analytics;
    this.locations = props.locations;
    this.state = {
      one: Object.keys(props.locations),
      one_slug: false,
      two: {},
      two_slug: false,
      three: {},
    };
  }

  loadTwo(slug, region) {
    this.setState(update(this.state,
      {
        $set: {
          one: this.state.one,
          one_slug: slug,
          two: region,
          three: [],
        },
      },
    ));
  }

  loadThree(slug, region) {
    if (!region && slug) {
      this.gotoMap(slug);
      return;
    }

    this.setState(update(this.state,
      {$set: {
        one: this.state.one,
        two: this.state.two,
        two_slug: slug,
        three: region,
      } }
    ));
  }

  gotoMap(slug) {
    if (canUseDOM) {
      window.location.assign(`/map/${slug}`);
    }
  }

  clickedCustomLocation = () => {}

  render() {
    let navClasses = super.getMenuClasses('locationMenu');
    let active = cx({
      'desktopLocationMenu': true,
      'active': true // this.props.openRef === 'locationMenu',
    });

    return (
      <div id="locationMenu" className={active}>
        <div className="locations container">
          <div className="row">
            <div className="region-column">
              <ul>
                {
                  this.state.one.map((region, index) => {
                    let oneActive = "";
                    if(this.state.two) {
                      oneActive = cx({
                        active: this.state.one_slug === region,
                      });
                    }

                    if (this.locations[region].name)
                      return (
                        <RegionLink
                          key={index}
                          className={oneActive}
                          onClick={this.loadTwo.bind(this, region, this.locations[region].children)}
                          region={this.locations[region]}
                        />
                      );
                  })
                }
              </ul>
            </div>
            <div className="region-column"
               style={{display: this.state.one_slug ? "block" : "none"}}>
              <ul>
              {(()=> {
                let twoKeys = Object.keys(this.state.two);
                return twoKeys.map((region, index) => {
                  let twoActive = "";
                  if(this.state.two_slug) {
                    twoActive = cx({
                      active: this.state.two_slug === region,
                    })
                  }

                  return (
                    <RegionLink
                      key={index}
                      className={twoActive}
                      onClick={this.loadThree.bind(this, region, this.state.two[region].children)}
                      region={this.state.two[region]}
                    />
                  );
                })
              })()}
              </ul>
            </div>
            <div className="region-column"
              style={{display: this.state.two_slug ? "block" : "none"}}>
              <ul>
                {(()=> {
                  let three = Object.keys(this.state.three);
                  return three.map((region, index) => {
                    return (
                        <RegionLink
                          key={index}
                          onClick={this.gotoMap.bind(this, this.state.three[region].slug)}
                          region={this.state.three[region]}
                        />
                    );
                  })
                })()}
              </ul>
            </div>
          </div>
          <div className="row">
            <div className="popular">
              <a href="/map/global" onClick={this.clickedCustomLocation} >
                Custom Location
              </a>
            </div>
            <div className="remainder"></div>
          </div>
        </div>
      </div>
    );
  }
}


class RegionLink extends React.Component {
  constructor(props) {
    super(props);
  }


  render() {
    if (this.props.region.children) {
      return (
        <li onClick={this.props.onClick} className={this.props.className}>
          <a href="#">
            {this.props.region.name} &nbsp;
            <i className="fa fa-caret-right"></i>
          </a>
        </li>
      );
    } else {
      return (
        <MapLink {...this.props} slug={this.props.region.slug}>
          {this.props.region.name}
        </MapLink>
      );
    }
  }
}


export default DesktopLocationMenu;



// WEBPACK FOOTER //
// ./src/components/GlobalHeader/menus/DesktopLocationMenu.js